import React from 'react';
import Lottie from 'react-lottie';
import './Whatsapp_Lottie.css';
import * as animationData from './Whatsapp_Lottie.json';

function Whatsapp_Lottie(props) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <section className='main'>
      <div className='success_div'>
        <div className='Whatsapp_Lottie_icon'>
          <Lottie className="me-auto"
            options={defaultOptions}
          // height={60}
          // width={60}          
          />
        </div>
        <p className='success_text'>{props?.successText}</p>
      </div>

    </section>
  );
}
export default Whatsapp_Lottie;